import { jwtDecode } from 'jwt-decode';

interface AuthToken {
  sub: string; // Email do usuário
  role: 'master' | 'padrao';
  exp: number;
}

export const useAuth = () => {
  const token = localStorage.getItem('ccomex_token');

  if (token) {
    try {
      const decodedToken = jwtDecode<AuthToken>(token);
      
      // Verifica se o token não expirou
      if (decodedToken.exp * 1000 > Date.now()) {
        return { isAuthenticated: true, role: decodedToken.role, email: decodedToken.sub };
      }
    } catch (error) {
      console.error("Erro ao decodificar o token:", error);
      return { isAuthenticated: false, role: null, email: null };
    }
  }

  return { isAuthenticated: false, role: null, email: null };
};